// User
export const USER_NOT_FOUND = "User not found";
export const USER_DATA_FETCH_ERROR = "Error fetching user data";
export const LOGIN_FAILED = "Login failed";
export const SESSION_EXPIRED = "Your session has expired. Please log in again.";

// User Registration
export const USER_REGISTER_FAILED = "Registration failed";
export const PLEASE_ENTER_FIRST_NAME = "Please enter your first name";
export const PLEASE_ENTER_LAST_NAME = "Please enter your last name";
export const PLEASE_ENTER_TDA_NUMBER = "Please enter your TDA number";
export const TDA_NUMBER_NOTE =
  "A TDA number is the license or registration number issued by the Texas Department of Agriculture to individuals, businesses, or entities that are regulated by the department.";
export const EMAILS_DONT_MATCH = "Emails don't match";
export const PLEASE_ENTER_MOBILE_NUMBER = "Please enter your mobile number";
export const PLEASE_ENTER_ADDRESS = "Please enter your address";
export const PLEASE_ENTER_CITY = "Please enter your city";
export const PLEASE_SELECT_STATE = "Please select your state";
export const PLEASE_ENTER_ZIP_CODE = "Please enter your zip code";
export const PLEASE_ENTER_SIGNUP_CODE = "Please enter a sign up code";
export const PLEASE_ENTER_LEGAL_ENTITY = "Please enter a legal entity";
export const PLEASE_ENTER_VALID_EMAIL = "Please enter a valid email";
export const PLEASE_ENTER_LEGAL_ENTITIES_NOTE =
  "Please enter all legal farm and business entities that belong to you.";
export const PLEASE_ENTER_PASSWORD = "Please enter your password";
export const PLEASE_ENTER_CONFIRM_PASSWORD = "Please confirm your password";
export const PASSWORDS_DONT_MATCH = "Passwords don't match";
export const PLEASE_ENTER_PASSWORD_8_CHARACTERS =
  "Password must have at least 8 characters";
export const PASSWORD_MUST_CONTAIN_NUMBER =
  "Password must contain at least 1 number";
export const PASSWORD_MUST_CONTAIN_UPPERCASE =
  "Password must contain at least 1 uppercase letter";
export const PASSWORD_MUST_CONTAIN_LOWERCASE =
  "Password must contain at least 1 lowercase letter";
export const PASSWORD_MUST_CONTAIN_SPECIAL_CHARACTER =
  "Password must contain at least 1 special character";
export const EMAIL_ALREADY_REGISTERED = "Email has already been registered";
export const ERROR_CONFIRMING_EMAIL = "Error confirming email";
export const PLEASE_TRY_AGAIN = "Please try again";
export const PLEASE_TRY_AGAIN_LATER = "Please try again later";
export const PLEASE_ACCEPT_TERMS_AND_CONDITIONS =
  "Please accept the terms and conditions";
export const PLEASE_ENTER_SIX_DIGIT_CONFIRMATION_CODE_SENT_TO_MOBILE =
  "We have sent a 6-digit confirmation code to your mobile number. Please enter the code below";

// User Registration Banner
export const BANNER_GFA_TEXT =
  "The Grower Freedom Alliance has been created to empower farmers by reshoring the production of generic agricultural chemicals to Texas. This initiative aims to shorten and secure the supply chain, reduce costs, and enhance the quality of essential farming inputs.";
export const BANNER_CHEM_APP_TEXT =
  "This application provides essential management tools for the agricultural operations of farmers. Track and organize your farming sites, create and monitor custom chemical formulations, and maintain detailed records of chemicals applied across all your sites and crops. Simplified visualisation of your agricultural practices and operations for better decision-making";

export const BANNER_CHEM_APP_RECIPE_TEXT =
  "Create and store chemical formulation recipes for easy application across your sites.";

export const BANNER_CHEM_APP_SITE_TEXT =
  "Register and manage all your site locations and keep track of your acreage and crop information.";

export const BANNER_CHEM_APP_RECIPE_USAGE_TEXT =
  "Monitor and maintain records of all applied chemicals on your sites and planted acres.";

// User Confirmation
export const PLEASE_ENTER_VALID_CONFIRMATION_CODE =
  "Please enter a valid 6-digit confirmation code";
export const REGISTRATION_SUCCESSFUL = "Registration successful.";
export const PLEASE_LOGIN_WITH_CREDENTIALS =
  "Please login with your credentials.";
export const REGISTRATION_FAILED = "Registration failed";
export const INVALID_CONFIRMATION_CODE = "Invalid confirmation code";
export const CONFIRMATION_FAILED = "Confirmation Failed";
export const CONFIRMATION_CODE_SENT = "Confirmation code sent successfully";
export const CONFIRMATION_CODE_SENT_FAILED = "Failed to send confirmation code";
export const CONFIRMATION_CODE_RESENT = "Confirmation code resent successfully";
export const CONFIRMATION_CODE_RESEND_FAILED =
  "Failed to resend confirmation code";

// Password Reset
export const PASSWORD_RESET_EMAIL_TEXT =
  "Enter your registered email address. A confirmation code will be sent to your registered mobile number to reset your password.";
export const PASSWORD_RESET_CODE_TEXT =
  "Enter the confirmation code sent to your mobile number linked to";
export const PASSWORD_RESET_SUCCESSFUL = "Password reset successful.";
export const PLEASE_LOGIN_WITH_NEW_PASSWORD =
  "Please login with your new password.";
export const INVALID_OTP = "Invalid OTP";

// Change Password
export const PASSWORD_CHANGED_SUCCESSFUL = "Password changed successfully";
export const PASSWORD_CHANGED_FAILED = "Password change failed";
export const PLEASE_ENTER_OLD_PASSWORD = "Please enter your old password";
export const NEW_PASSWORD_DIFFERENT_FROM_OLD_PASSWORD =
  "New password must be different from old password";

// User Profile
export const PROFILE_FETCH_ERROR = "Error fetching user profile";
export const PROFILE_UPDATE_ERROR = "Error updating user profile";
export const PROFILE_UPDATE_SUCCESSFUL = "Profile updated successfully";

// Sites
export const REGISTERED_SITE = "You have successfully registered the site:";
export const SHARED_SITES_WITH =
  "You have successfully shared the following sites with";
export const UPDATED_SITE = "You have successfully updated the site";
export const SITE_HAS_BEEN_DELETED_SUCCESSFULLY =
  "Site has been deleted successfully";
export const SITE_DELETE_ERROR = "Error deleting site";
export const SITE_STOP_SHARE_ERROR = "Error stopping share site";
export const SITE_FETCH_ERROR = "Error fetching sites";
export const BUSINESS_AND_FARMS_FETCH_ERROR =
  "Error fetching businesses and farms";
export const SITE_REGISTRATION_ERROR = "Error registering site";
export const SITE_UPDATE_ERROR = "Error updating site";
export const ARE_YOU_SURE_DELETE_SITE =
  "Are you sure you want to delete the site";
export const ARE_YOU_SURE_STOP_SHARE_SITE =
  "Are you sure you want to stop share for the site";
export const PLEASE_ENTER_SITE_NAME = "Please enter a site name";
export const PLEASE_SELECT_FARM = "Please select a farm";
export const PLEASE_ENTER_TOTAL_ACRES = "Please enter total acres";
export const TOTAL_ACRES_MUST_BE_GREATER_THAN_ZERO =
  "Total acres must be greater than 0";
export const PLEASE_ENTER_FALLOW_ACRES = "Please enter fallow acres";
export const FALLOW_ACRES_CANNOT_EXCEED_TOTAL_ACRES =
  "Fallow acres can't exceed total acres";
export const PLEASE_SELECT_AT_LEAST_ONE_SITE =
  "Please select at least one site";
export const PLEASE_ENTER_FARM_NAME = "Please enter a farm name";
export const PLEASE_SELECT_BUSINESS = "Please select a business";
export const PLEASE_ENTER_BUSINESS_NAME = "Please enter a business name";
export const SELECT_SITE_LOCATION_ON_MAP = "Select a site location on the map";
export const PLEASE_SELECT_SITE_LOCATION_ON_MAP =
  "Please select a site location on the map";
export const BUSINESS_NAME_ALREADY_EXISTS = "Business name already exists";
export const FARM_NAME_ALREADY_EXISTS = "Farm name already exists";
export const SITE_NAME_ALREADY_EXISTS = "Site name already exists";
export const SITE_SHARING_HAS_BEEN_PAUSED = "Site sharing has been paused";
export const SITE_SHARING_HAS_BEEN_STOPPED = "Site sharing has been stopped";
export const SITE_HAS_BEEN_RE_SHARED = "Site has been re-shared successfully";
export const ERROR_FETCHING_SHARED_SITES = "Error fetching shared sites";

// Recipes
export const ADDED_RECIPE = "You have successfully added the recipe";
export const SHARED_RECIPES_WITH =
  "You have successfully shared the following recipes with";
export const UPDATED_RECIPE = "You have successfully updated the recipe";
export const NEW_VERSION_FOR_RECIPE =
  "You have created a new version for recipe";
export const RECIPE_ADD_ERROR = "Error adding recipe";
export const RECIPE_DELETE_ERROR = "Error deleting recipe";
export const RECIPE_HAS_BEEN_DELETED_SUCCESSFULLY =
  "Recipe has been deleted successfully";
export const RECIPE_ARCHIVE_ERROR = "Error archiving recipe";
export const RECIPE_HAS_BEEN_ARCHIVED_SUCCESSFULLY =
  "Recipe has been archived successfully";
export const RECIPE_HAS_BEEN_UNARCHIVED_SUCCESSFULLY =
  "Recipe has been unarchived successfully";
export const RECIPE_FETCH_ERROR = "Error fetching recipes";
export const RECIPE_SAVE_ERROR = "Error saving recipe";
export const RECIPE_UPDATE_ERROR = "Error updating recipe";
export const ARE_YOU_SURE_DELETE_RECIPE =
  "Are you sure you want to delete the recipe";
export const ARE_YOU_SURE_ARCHIVE_RECIPE =
  "Are you sure you want to archive the recipe";
export const ARE_YOU_SURE_UNARCHIVE_RECIPE =
  "Are you sure you want to unarchive the recipe";
export const PLEASE_ENTER_RECIPE_NAME = "Please enter a recipe name";
export const PLEASE_SELECT_RECIPE_TYPE = "Please select a recipe type";
export const PLEASE_ENTER_WATER_AMOUNT = "Please enter water amount";
export const PLEASE_FILL_REQUIRED_FIELDS_FOR_CHEMICALS =
  "Please fill required fields for chemicals";
export const PLEASE_SELECT_CHEMICAL = "Please select a chemical";
export const PLEASE_SELECT_UNIT = "Please select a unit";
export const PLEASE_ENTER_QUANTITY = "Please enter quantity";
export const QUANTITY_MUST_BE_GREATER_THAN_ZERO =
  "Quantity must be greater than 0";
export const PLEASE_SELECT_AT_LEAST_ONE_RECIPE =
  "Please select at least one recipe";
export const PLEASE_SEARCH_AND_SELECT_FARMER =
  "Please search and select a farmer";
export const PLEASE_SELECT_FARMER = "Please select the farmer";
export const CHEMICAL_FETCH_ERROR = "Error fetching chemicals";
export const RECIPE_TYPE_FETCH_ERROR = "Error fetching recipe types";
export const RECIPE_SHARING_HAS_BEEN_PAUSED = "Recipe sharing has been paused";
export const RECIPE_HAS_BEEN_RE_SHARED =
  "Recipe has been re-shared successfully";
export const ERROR_UPDATING_SHARE_DETAILS = "Error updating share details";
export const RECIPE_SHARE_ERROR = "Error sharing recipes";
export const ERROR_FETCHING_SHARED_RECIPES = "Error fetching shared recipes";
export const SITE_SHARE_ERROR = "Error sharing sites";

// Recipes Usage
export const ADDED_RECIPE_USAGE =
  "You have successfully added the recipe usage";
export const UPDATED_RECIPE_USAGE =
  "You have successfully updated the recipe usage";
export const RECIPE_USAGE_DELETE_ERROR = "Error deleting recipe usage";
export const RECIPE_USAGE_HAS_BEEN_DELETED_SUCCESSFULLY =
  "Recipe usage has been deleted successfully";
export const RECIPE_USAGE_FETCH_ERROR = "Error fetching recipe usage";
export const RECIPE_USAGE_SAVE_ERROR = "Error saving recipe usage";
export const ARE_YOU_SURE_SAVE_RECIPE_USAGE =
  "Are you sure you want to save these changes";
export const ARE_YOU_SURE_DELETE_RECIPE_USAGE =
  "Are you sure you want to delete this recipe usage";
export const PLEASE_SELECT_RECIPE = "Please select a recipe";
export const PLEASE_SELECT_APPLICATION_DATE =
  "Please select an application date";
export const PLEASE_ENTER_SPRAYED_ACRES = "Please enter sprayed acres";
export const SPRAYED_ACRES_MUST_BE_GREATER_THAN_ZERO =
  "Sprayed acres must be greater than 0";
export const SPRAYED_ACRES_CANNOT_EXCEED_TOTAL_ACRES =
  "Sprayed acres cannot exceed total acres";
export const PLEASE_ENTER_WATER_QUANTITY = "Please enter water quantity";
export const WATER_QUANTITY_MUST_BE_GREATER_THAN_ZERO =
  "Water quantity must be greater than 0";
export const USAGE_CONTAINS_THE_FOLLOWING_CHEMICALS =
  "This usage contains the following chemicals";

// Planted acres
export const ADDED_PLANTED_ACRES =
  "You have successfully added new planted acres";
export const UPDATED_PLANTED_ACRES =
  "You have successfully updated the planted acres";
export const PLANTED_ACRES_HAS_BEEN_DELETED_SUCCESSFULLY =
  "Planted acres has been deleted successfully";
export const PLANTED_ACRES_DELETE_ERROR = "Error deleting planted acres";
export const PLANTED_ACRES_FETCH_ERROR = "Error fetching planted acres";
export const PLANTED_ACRES_SAVE_ERROR = "Error saving planted acres";
export const ARE_YOU_SURE_DELETE_PLANTED_ACRES =
  "Are you sure you want to delete the planted acres";
export const PLEASE_ENTER_PLANTED_ACRES_NAME =
  "Please enter planted acres name";
export const PLEASE_SELECT_STATUS = "Please select a status";
export const PLEASE_ENTER_FAILED_ACRES = "Please enter failed acres";
export const PLEASE_SELECT_CROP = "Please select a crop";
export const PLEASE_SELECT_SEED = "Please select a seed";
export const PLEASE_SELECT_TILLAGE = "Please select a tillage";
export const PLEASE_ENTER_ACRES = "Please enter acres";
export const ACRES_MUST_BE_GREATER_THAN_ZERO = "Acres must be greater than 0";
export const PLEASE_SELECT_DATE = "Please select a date";
export const PLEASE_ENTER_SEEDING_AMOUNT = "Please enter seeding amount";
export const PLEASE_ENTER_ROW_SPACING = "Please enter row spacing";
export const PLEASE_SELECT_PATTERN = "Please select a pattern";
export const FAILED_ACRES_CANNOT_EXCEED_ACRES =
  "Failed acres cannot exceed acres";
export const PLANTED_ACRES_OPTIONS_FETCH_ERROR =
  "Error fetching planted acres options";
export const PLANTED_ACRES_NAME_ALREADY_EXISTS =
  "Planted acres name already exists";
export const REPLANTING_FOR_NOTE = "This planted acres has been replanted on";
export const FAILED_FROM_NOTE = "This planted acres has been failed from";

// Timeline
export const TIMELINE_FETCH_ERROR = "Error fetching timeline";

// Notes
export const NOTE_ADD_ERROR = "Error adding note";
export const NOTE_DELETE_ERROR = "Error deleting note";
export const NOTE_DELETED_SUCCESSFULLY = "Note deleted successfully";
export const NOTE_RESOLVE_ERROR = "Error resolving note";
export const NOTE_FETCH_ERROR = "Error fetching notes";
export const NOTE_TAGS_FETCH_ERROR = "Error fetching notes tags";
export const PLEASE_ENTER_A_NOTE = "Please enter a note";
export const NO_PENDING_NOTES_FOUND = "No pending notes found";
export const NO_RESOLVED_NOTES_FOUND = "No resolved notes found";
export const NOTE_ADDED_SUCCESSFULLY = "Note added successfully";
export const NOTE_RESOLVED_SUCCESSFULLY = "Note resolved successfully";
export const TYPE_TO_CREATE_A_NEW_TAG = "Type to create a new tag";
export const SELECT_OR_CREATE_TAGS = "Select or create tags";

export const FEATURE_UNDER_CONSTRUCTION = "Feature Under Construction";

// Placeholders
export const LABEL_ENTER_USERNAME = "Enter Username";
export const LABEL_ENTER_PASSWORD = "Enter Password";
export const LABEL_ENTER_FIRST_NAME = "Enter First Name";
export const LABEL_ENTER_LAST_NAME = "Enter Last Name";
export const LABEL_ENTER_TDA_NUMBER = "Enter TDA Number";
export const LABEL_ENTER_MOBILE_NUMBER = "Enter Mobile Number";
export const LABEL_ENTER_ADDRESS = "Enter Address";
export const LABEL_ENTER_CITY = "Enter City";
export const LABEL_ENTER_ZIP_CODE = "Enter Zip Code";
export const LABEL_ENTER_SIGNUP_CODE = "Enter Signup Code";
export const LABEL_ENTER_LEGAL_ENTITY = "Enter Legal Entity";
export const LABEL_ENTER_OLD_PASSWORD = "Enter Old Password";
export const LABEL_ENTER_NEW_PASSWORD = "Enter New Password";
export const LABEL_ENTER_CONFIRM_PASSWORD = "Enter Confirm Password";
export const LABEL_ENTER_CONFIRMATION_CODE = "000000";
export const LABEL_ENTER_SITE_NAME = "Enter Site Name";
export const LABEL_ADD_A_NOTE = "Add a note";
export const LABEL_ENTER_TOTAL_ACRES = "Enter Total Acres";
export const LABEL_ENTER_FALLOW_ACRES = "Enter Fallow Acres";
export const LABEL_ENTER_FARM_NAME = "Enter Farm Name";
export const LABEL_ENTER_BUSINESS_NAME = "Enter Business Name";
export const LABEL_ENTER_RECIPE_NAME = "Enter Recipe Name";
export const LABEL_ENTER_WATER_AMOUNT = "Enter Water Amount";
export const LABEL_ENTER_QUANTITY = "Enter Quantity";
export const LABEL_ENTER_EMAIL = "Enter Email";
export const LABEL_SELECT_BUSINESS = "Select Business";
export const LABEL_SELECT_FARMS = "Select Farms";
export const LABEL_SELECT_CHEMICAL = "Select Chemical";
export const LABEL_SELECT_TYPE = "Select Type";
export const LABEL_SELECT_RECIPE = "Select Recipe";
export const LABEL_SELECT_PLANTED_ACRES = "Select Planted Acres";
export const LABEL_SELECT_CROP = "Select Crop";
export const LABEL_SELECT_SEED_TYPE = "Select Seed Type";
export const LABEL_SELECT_STATUS = "Select Status";
export const LABEL_SELECT_DATE_RANGE = "Select Date Range";
export const LABEL_SELECT_UNIT = "Select Unit";
export const LABEL_SELECT_STATE = "Select State";
export const LABEL_REPLANTING_FAILED_ACRES = "Replanting Failed Acres";
export const LABEL_SELECT_FAILED_ACRES = "Select Failed Acres";
export const LABEL_SELECT_SEED = "Select Seed";
export const LABEL_SELECT_TILLAGE = "Select Tillage";
export const LABEL_SELECT_PATTERN = "Select Pattern";
export const LABEL_SELECT_FARM = "Select Farm";
export const LABEL_SELECT_RECIPES_TO_SHARE = "Select Recipes To Share";
export const LABEL_SELECT_SITES_TO_SHARE = "Select Sites To Share";
export const LABEL_SELECT_BUSINESS_AND_FARMS_TO_DISPLAY =
  "Select Business And Farms To Display";
export const LABEL_SITES_WITH_NO_CROPS = "Sites With No Crops";
export const LABEL_CHEMICAL_FREE_CROP_SITES = "Chemical-Free Crop Sites";
export const LABEL_SEARCH_SITES = "Search sites";
export const LABEL_SEARCH_RECIPE = "Search by name or chemical details";
export const LABEL_SEARCH_PLANTED_ACRES = "Search planted acres";
export const LABEL_ENTER_WATER_QUANTITY = "Enter Water Quantity";
// Map Labels
export const FULL_SCREEN = "Full Screen";
export const STREET_VIEW = "Street View";
export const LABEL_VIEW = "Label View";

// Empty States
export const NO_SITES_FOUND = "No Sites Found";
export const NO_RECIPES_FOUND = "No Recipes Found";
export const NO_PLANTED_ACRES_FOUND = "No Planted Acres Found";
export const NO_TIMELINE_EVENTS_FOUND = "No Timeline Events Found";
export const NO_RECIPES_APPLIED = "No Recipes Applied Yet";
export const NO_SHARED_RECIPES = "No Recipes Shared With You";
export const NO_ARCHIVED_RECIPES = "No Archived Recipes Found";
export const NO_SHARED_SITES = "No Sites Shared With You";
export const LABEL_ENTER_FAILED_ACRES = "Enter Failed Acres";
export const LABEL_ENTER_PLANTED_ACRES_NAME = "Enter Planted Acres Name";
export const LABEL_ENTER_ACRES = "Enter Acres";
export const LABEL_ENTER_SEEDING_AMOUNT = "Enter Seeding Amount";
export const LABEL_ENTER_ROW_SPACING = "Enter Row Spacing";

export const ADD_NEW_SITE = "Add New Site";
export const VIEW_SITE = "View Site";
export const EDIT_SITE = "Edit Site";

export const ADD_FARM_AND_BUSINESS = "Add Farm and Business";
export const NEW_FARM = "New Farm";
export const NEW_BUSINESS = "New Business";

export const ADD_PLANTED_ACRES = "Add Planted Acres";
export const EDIT_PLANTED_ACRES = "Edit Planted Acres";
export const VIEW_PLANTED_ACRES = "View Planted Acres";

export const ADD_CHEMICAL = "Add Chemical";
export const ADD_CHEMICAL_RECIPE = "Add Chemical Recipe";
export const EDIT_CHEMICAL_RECIPE = "Edit Chemical Recipe";
export const VIEW_CHEMICAL_RECIPE = "View Chemical Recipe";

export const ADD_RECIPE_USAGE = "Add Recipe Usage";
export const EDIT_RECIPE_USAGE = "Edit Recipe Usage";
export const VIEW_RECIPE_USAGE = "View Recipe Usage";

export const ADD_ENTITY = "Add Entity";
export const ADD_NOTE = "Add Note";
